import React from 'react';
import { Icon } from 'semantic-ui-react';
import moment from 'moment';

class OSCardAgent extends React.Component{

    constructor(props){
        super(props)
    }

    render(){
        return (
            <div className="OSCardContainer2">
                <div className="OSNameContainer">
                 {this.props.name}    
                </div>
                <div className="OSContentContainer2">
                    <div className="OSContentLocation"><Icon name = 'marker' size = 'small' bordered='true' inverted='true' color='blue'/>{this.props.address}</div>
                    <div className="OSContentTel"><Icon name = 'phone' size = 'small' color='blue' link='true'/>{this.props.telephone}</div>
                    <div className="OSContentFax"><Icon name = 'fax' size = 'small' color='blue' bordered='true'/>{this.props.fax}</div>
                    <div className="OSContentUrl"><Icon name = 'globe' size = 'small' inverted='true'  color='blue' circular='true'/>{this.props.webSiteUrl}</div>
                </div>
                {/* <div className="OSCardAction"></div> */}
            </div>
        )
    }

}

export default OSCardAgent;


// WEBPACK FOOTER //
// ./src/components/OSCardAgent/OSCardAgent.js